import { render, staticRenderFns } from "./InnerShadowBIcon.vue?vue&type=template&id=3e611439&"
import script from "./InnerShadowBIcon.vue?vue&type=script&lang=js&"
export * from "./InnerShadowBIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports